// Services
import registerService from '@/app/services/main/register/register-service.js';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Constants
import { GA } from '@/app/constants/ga-constants';
import { STATUS_CODES } from '@/app/constants/status-constants';

// Mixins
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

export default {
	name: 'AddHuman',
    mixins: [
        GoogleAnalyticsMixins,
		dateMixins,
		toastMessageMixins
    ],
	data() {
		return {
			inputFields: {
				firstName: '',
				lastName: '',
				email: '',
				selectedTimeZone: 'Australia/Sydney'
			},
			isAgreeTNC: false,
			isAPILoading: false
		}
	},
	computed: {
		validationRules() {
			let fields = {
                inputFields: {
                    firstName: {},
                    lastName: {},
                    email: {}
                }
			};

			fields.inputFields = vuelidateUtil.setFieldsRequired(fields.inputFields, true);
			fields.inputFields = vuelidateUtil.setEmailValidation(fields.inputFields, 'email');
			return fields;
		},
		isDisabled() {
			return this.$v.$invalid || !this.isAgreeTNC || this.isAPILoading;
        },
		authStatus() {
			return this.$store.getters.getAuthMessage;
		}
    },
	methods: {
        setActiveComponent() {
			if(this.$route.path === "/create-account"){
				this.$router.push('/');
			}else{
				this.$emit('setActiveComponent', 'add-pet');
			}
			
		},
		sendSocialMediaRegistrationAnalytics(isFB) {
        	let action = isFB ? GA.REGISTRATION_PAGE.CREATE_ACCOUNT_WITH_FB_BUTTON.ACTION : GA.REGISTRATION_PAGE.CREATE_ACCOUNT_WITH_GOOGLE_BUTTON.ACTION;
        	let label = isFB ? GA.REGISTRATION_PAGE.CREATE_ACCOUNT_WITH_FB_BUTTON.LABEL : GA.REGISTRATION_PAGE.CREATE_ACCOUNT_WITH_GOOGLE_BUTTON.LABEL;

        	this.sendEventTrackingToGA(action, GA.REGISTRATION_PAGE.CATEGORY, label);
		},
		onAddHuman() {
			if (this.isDisabled) {
				return;
            }

			this.commitAuthStatus('', '');

            this.isAPILoading = true;

			let registerDetails = {};

			if(this.$route.path === "/create-account"){
				registerDetails ={
					formDetails: {
						"userDetails": {
							"firstName": this.inputFields.firstName,
							"lastName": this.inputFields.lastName,
							"defaultTimezone": this.inputFields.selectedTimeZone,
							"email": this.inputFields.email
						},
					}
				};
			}else{
				
				const petImg = this.$store.getters.getAddPetDetails.petImageUpload[0];

				registerDetails ={
					formDetails: {
						"petDetails": {
							"name": this.$store.getters.getAddPetDetails.name,
							"breedId": parseInt(this.$store.getters.getAddPetDetails.breedId),
							"birthdate": this.dateToISO(this.$store.getters.getAddPetDetails.birthdate),
							"gender": this.$store.getters.getAddPetDetails.gender,
							"newBreed": {}
						},
						"userDetails": {
							"firstName": this.inputFields.firstName,
							"lastName": this.inputFields.lastName,
							"defaultTimezone": this.inputFields.selectedTimeZone,
							"email": this.inputFields.email
						},
					},
					petImg
				};

				if (parseInt(this.$store.getters.getAddPetDetails.breedId) <= 0) {
					registerDetails.formDetails.petDetails.newBreed = {
						breedName: this.$store.getters.getAddPetDetails.breedName,
						breedSize: this.$store.getters.getAddPetDetails.breedSize
					}
				}
			}

            // lmdc register api
            registerService.postRegister(registerDetails)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                        this.isAPILoading = false;

                        // clear stored pet Details
                        this.$store.commit('clearAddPetDetails');

                        // Send Analytics
						this.sendEventTrackingToGA(GA.REGISTRATION_PAGE.CREATE_ACCOUNT_BUTTON.ACTION, GA.REGISTRATION_PAGE.CATEGORY, GA.REGISTRATION_PAGE.CREATE_ACCOUNT_BUTTON.LABEL);

                        this.$swal({
							imageHeight: '30px',
                            imageUrl: `${require('@/assets/images/_shared/success-dog.png')}`,
                            imageAlt: 'Success Dog',
                            title: 'Awesome!',
                            text: 'Please check your email for verification.',
                            confirmButtonColor: '#4B8BFF',
                            confirmButtonText: 'Got it'
                        }).then(() => {
                            this.$router.push('/');
                        });
                    } else {
						this.isAPILoading = false;
                        this.commitAuthStatus('failed', res.data.errors);
                    }
                });

		},
		commitAuthStatus(status, message) {
        	this.$store.commit('setAuthMessage', {status, message});
		}
	},
	validations() {
		return this.validationRules;
	}
}